import { Component } from '@angular/core';
import { membersuiteFundraisingProductEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Fundraising Products') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitefundraisingproduct-form',
    templateUrl: './membersuitefundraisingproduct.form.component.html'
})
export class membersuiteFundraisingProductFormComponent extends BaseFormComponent {
    public record!: membersuiteFundraisingProductEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

